/* eslint-disable */

//Add map layers with points to mapbox map, from data source
//Adds interactivity to the map points


import highlightMapList from '../helpers/highlightMapList';

// eslint-disable-next-line import/no-unresolved
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';

import '~styles/modules/mapbox.scss';

//For converting json to geojson
//https://www.npmjs.com/package/geojson
var GeoJSON = require('geojson');

//mapbox variables
mapboxgl.accessToken = 'pk.eyJ1IjoiYm9zdG9uZ2xvYmUtbWFwYm94IiwiYSI6ImNrMXMzdzRjdzBjMTUzYmxnYWFicjk3dWkifQ.Pqincssv6-WMTdbuGiAyHw';

let categories = ["shopping", "entertainment", "food", "outdoors"];
let itemIdSuffix = "-description-container";
let mapListItemsClass = "map-entry-containers";
let pointActive = false;

const BuildMap = (map, sourceName,mapData,pointsLayerName)=>{

	//Add map source:

    //Can't add sources twice
    //If base hasn't been set, add base and other sources for first time, otherwise simply update the sources
    if (!map.getSource(sourceName)){
      map.addSource(sourceName, {
        'type': 'geojson',
        'data': mapData
      });
     
    }else{
      map.getSource(sourceName).setData(mapData)

    }

    //remove old layer to replace with new
    if (map.getLayer(pointsLayerName)){
      map.removeLayer(pointsLayerName);

    } 
   
    //Add points and color them based on Color property from data
    map.addLayer({
      'id': pointsLayerName,
      'type': 'circle',
      'source': sourceName,
      'paint': {
        'circle-color': [
        'match',
        ['get', 'Color'],
        'entertainment',
        '#227985',
        'food',
        '#DF4B27',
        'outdoors',
        '#0F743D',
        'shopping',
        '#DAA739',
        /* other */ '#ccc'
        ]
      }
    });

    //Events:
   
   //Reset map list when user clicks on map (but not a point)
   //Has to be before pointsLayer click event

   map.on('click', function (e) {
     if (e.defaultPrevented === false) {

           let listItems = document.getElementsByClassName(mapListItemsClass)

           //Only reset if a point is active is
           if(pointActive){
             highlightMapList.resetMapItems(listItems)
             pointActive = false;
           }
       }
     
   });

   //If user clicks a point, make it active and show its details in side list:
   map.on('click', pointsLayerName, function (e) {

      let targetItemName = e.features[0].properties.Unique_Slug+itemIdSuffix;
      let listItems = document.getElementsByClassName(mapListItemsClass)
     
      //If a point isn't active, make it active and highlight its content on the list; If a point is active, reset and show all items on list
      if(!pointActive){
         highlightMapList.highlightMapItem(listItems,targetItemName);
         pointActive = true;
      }else{
         highlightMapList.resetMapItems(listItems)
         pointActive = false;
      }

      //Zoom map to correct point
      var coordinates = e.features[0].geometry.coordinates.slice();
      var description = e.features[0].properties.Name;
       
      // Ensure that if the map is zoomed out such that multiple
      // copies of the feature are visible, the popup appears
      // over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      // new mapboxgl.Popup()
      //   .setLngLat(coordinates)
      //   .setHTML(description)
      //   .addTo(map);
    });
     

    // Change the cursor to a pointer when the mouse is over the places layer.
    //show all items in map list
    map.on('mouseenter', pointsLayerName, function (e) {
      map.getCanvas().style.cursor = 'pointer';

      let targetItemName = e.features[0].properties.Unique_Slug+itemIdSuffix;
      let listItems = document.getElementsByClassName(mapListItemsClass)

      //Only reset if no item is higlighted by click
      if(!pointActive){
        highlightMapList.highlightMapItem(listItems,targetItemName)
      }
    });
     
    // Change it back to a pointer when it leaves.
    //reset map list
    map.on('mouseleave', pointsLayerName, function () {
      map.getCanvas().style.cursor = '';

      let listItems = document.getElementsByClassName(mapListItemsClass)

      //Only reset if no item is higlighted by click
      if(!pointActive){
        highlightMapList.resetMapItems(listItems)
      }
      
    });


////////////

    //For div-style markers

    // for (const feature of mapData.features) {
    //   // create a HTML element for each feature
    //   const el = document.createElement('div');
    //   el.className = 'markers '+feature.properties.Color+"-markers";
    //   el.id =feature.properties.Unique_Slug+"AAA"
    //   el.setAttribute("data-join", feature.properties.Unique_Slug+itemIdSuffix)

    //   // make a marker for each feature and add to the map
    //   new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(map);
    // }

    // let allMarkers = document.getElementsByClassName('markers')
    // for (let i = 0; i < allMarkers.length; i++ ){
    //   let currentMarker = allMarkers[i];

    //   currentMarker.addEventListener('click', function () {

    //         let targetItemName = this.dataset.join;
    //         let listItems = document.getElementsByClassName(mapListItemsClass)
           
    //         //If a point isn't active, make it active and highlight its content on the list; If a point is active, reset and show all items on list
    //         if(!pointActive){
    //            highlightMapList.highlightMapItem(listItems,targetItemName);
    //            pointActive = true;
    //         }else{
    //            highlightMapList.resetMapItems(listItems)
    //            pointActive = false;
    //         }     
    //   })
    // }



}


export default BuildMap